var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 6.378,
    viewBox: "0 0 16 6.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_950",
    "data-name": "\\u30D1\\u30B9 950",
    d: "M10.372,8a8.343,8.343,0,0,0-5.5,2.073L3.363,8.566A.8.8,0,0,0,2,9.124v4.457a.8.8,0,0,0,.8.8H7.254a.8.8,0,0,0,.566-1.363L6.3,11.492a6.349,6.349,0,0,1,9.815,2.089.98.98,0,0,0,1.2.51,1,1,0,0,0,.6-1.371A8.4,8.4,0,0,0,10.372,8Z",
    transform: "translate(-2 -8)",
    fill: "#8b8b8b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackGray);
export default __webpack_public_path__ + "static/media/icon_back_gray.65cfd954d44d3921e9a27930d9293a75.svg";
export { ForwardRef as ReactComponent };